import apiClient from '../apiClient';
import { DELETE_USER_PROFILE_URL } from '../apiUrl';

const deleteUserProfileApi = Id => {
  return apiClient.delete(DELETE_USER_PROFILE_URL(Id));
};

export default deleteUserProfileApi;
